import { Document, Svg, Path} from '@react-pdf/renderer';
import * as React from 'react';

import GeneralConstants from '../../constants/general.constants';
import {
	FormDataContainer,
	FormDataContainerWrapper,
	FormDataContent,
	FormDataContentContainer,
	FormDataTitle,
	FormDataTitleContainer,
	ImgContainer,
	InputHeader,
	InputHeaderText,
	InputWrapper,
	PageContainer
} from './styles';

const PdfBathroom = ({ orderType, activeFormData }) => {
	const formatDateToDayAndMonthAndYear = (date) => {
		const formatDate = date.split('T')[0];
		return formatDate
			? // eslint-disable-next-line max-len
			  `${formatDate[8]}${formatDate[9]}.${formatDate[5]}${formatDate[6]}.${formatDate[0]}${formatDate[1]}${formatDate[2]}${formatDate[3]}`
			: '-';
	};

	const { knapphus } = orderType;
	return (
		<Document>
			<PageContainer size='A4'>
				<ImgContainer>
					<Svg width="200" height="40" viewBox="0 0 205 62" preserveAspectRatio="xMidYMid meet">
						<Path fill="#fff" d="M55.588 50.823l3.177-4.3h2.807l-4.024 5.45 4.518 6.582h-2.983L55.89 53.83l-1.165 1.397v3.327h-2.47V46.524h2.47v4.158c0 .584-.088 1.415-.159 2.017.282-.637.653-1.38 1.023-1.876zM63.302 56.45l2.012-1.22c.388.689.741 1.273 1.588 1.273.812 0 1.324-.318 1.324-1.557v-8.421h2.47v8.456c0 2.566-1.5 3.733-3.688 3.733-1.977 0-3.123-1.026-3.706-2.265zM83.456 52.54c0-.673-.123-1.31-.353-1.84l-5.435 5.2c.581.408 1.288.62 2.1.62 2.187 0 3.688-1.734 3.688-3.98zm-1.588-3.344c-.566-.407-1.289-.637-2.1-.637-2.19 0-3.689 1.734-3.689 3.98 0 .69.124 1.31.37 1.858l5.419-5.201zm-8.525 8.173l1.306-1.238a6.312 6.312 0 0 1-1.094-3.592c0-3.556 2.753-6.174 6.213-6.174 1.429 0 2.735.443 3.776 1.22l1.27-1.22 1.378 1.362-1.307 1.239c.689.99 1.094 2.211 1.094 3.573 0 3.556-2.752 6.175-6.211 6.175a6.363 6.363 0 0 1-3.76-1.203c-.67.637-1.288 1.22-1.288 1.22l-1.377-1.362zM92.3 50.823l3.178-4.3h2.806l-4.024 5.45 4.519 6.582h-2.983L92.6 53.83l-1.165 1.397v3.327h-2.47V46.524h2.47v4.158c0 .584-.088 1.415-.159 2.017.283-.637.653-1.38 1.024-1.876zM104.638 50.823l3.177-4.3h2.807l-4.025 5.45 4.519 6.582h-2.983l-3.194-4.724-1.165 1.397v3.327h-2.471V46.524h2.471v4.158c0 .584-.089 1.415-.159 2.017.282-.637.653-1.38 1.023-1.876zM113.64 46.524h7.942v2.175h-5.471v3.822h4.818v2.124h-4.818v1.733h5.718v2.176h-8.189v-12.03zM128.573 52.964c-.6-.566-1.429-1.645-1.429-1.645s.176 1.327.176 2.194v5.041h-2.312V46.418h.247l6.054 5.697c.581.548 1.412 1.645 1.412 1.645s-.159-1.362-.159-2.193v-5.043h2.311v12.137h-.247l-6.053-5.697zM137.221 56.184l2.012-1.167c.529.866 1.218 1.503 2.435 1.503 1.024 0 1.676-.513 1.676-1.22 0-.85-.67-1.15-1.799-1.645l-.619-.266c-1.781-.76-2.964-1.716-2.964-3.733 0-1.857 1.412-3.273 3.618-3.273 1.571 0 2.7.549 3.511 1.982l-1.923 1.238c-.423-.76-.882-1.061-1.588-1.061-.724 0-1.182.46-1.182 1.061 0 .743.458 1.044 1.517 1.504l.617.265c2.101.902 3.284 1.823 3.284 3.892 0 2.23-1.748 3.45-4.095 3.45-2.294 0-3.777-1.097-4.5-2.53zM148.62 46.524h7.941v2.175h-5.471v3.822h4.819v2.124h-4.819v1.733h5.719v2.176h-8.189v-12.03zM163.552 52.964c-.6-.566-1.429-1.645-1.429-1.645s.176 1.327.176 2.194v5.041h-2.312V46.418h.247l6.054 5.697c.581.548 1.412 1.645 1.412 1.645s-.159-1.362-.159-2.193v-5.043h2.311v12.137h-.247l-6.053-5.697zM175.974 48.7h-3.424v-2.175h9.318V48.7h-3.424v9.854h-2.47V48.7zM184.575 46.524h7.942v2.175h-5.471v3.822h4.818v2.124h-4.818v1.733h5.718v2.176h-8.189v-12.03zM199.184 53.406c2.011 0 2.895-.637 2.895-2.335s-.918-2.37-2.895-2.37h-.776v4.705h.776zm5.612 5.149h-2.859l-1.977-3.044a4.757 4.757 0 0 1-.706.054h-.846v2.99h-2.472v-12.03h3.318c3.353 0 5.365 1.61 5.365 4.546 0 1.875-.829 3.06-2.312 3.733l2.489 3.75zM57.982 27.99l5.456-7.367h4.821l-6.912 9.336 7.76 11.277h-5.122l-5.488-8.094-2 2.396v5.698h-4.244V20.623h4.244v7.123c0 1-.151 2.425-.273 3.456.485-1.091 1.121-2.364 1.758-3.213zM78.052 31.657c-1.03-.97-2.455-2.819-2.455-2.819s.303 2.273.303 3.758v8.64h-3.97V20.44h.423l10.398 9.762c1 .94 2.425 2.82 2.425 2.82s-.273-2.335-.273-3.76v-8.64h3.971v20.796h-.424l-10.398-9.76zM103.582 35.355l-1.485-3.577c-.607-1.454-1.243-3.698-1.243-3.698s-.607 2.244-1.213 3.698l-1.484 3.577h5.425zm-2.85-14.915h.364l9.428 20.796h-4.457l-.969-2.334h-8.367l-.97 2.334h-4.093l9.064-20.796zM118.893 32.81c3.456 0 4.972-1.396 4.972-4.215 0-2.85-1.577-4.244-4.972-4.244h-1.334v8.458h1.334zm-5.578-12.187h5.699c5.76 0 9.216 3.001 9.216 7.972 0 4.972-3.487 7.943-9.216 7.943h-1.455v4.699h-4.244V20.623zM137.111 32.81c3.456 0 4.972-1.396 4.972-4.215 0-2.85-1.576-4.244-4.972-4.244h-1.333v8.458h1.333zm-5.577-12.187h5.699c5.759 0 9.215 3.001 9.215 7.972 0 4.972-3.486 7.943-9.215 7.943h-1.455v4.699h-4.244V20.623zM149.758 20.623h4.244v10.55h8.822v-10.55h4.243v20.614h-4.243V34.96h-8.822v6.276h-4.244V20.623zM171.286 33.78V20.622h4.244v12.914c0 3 1.304 4.153 4.124 4.153 2.788 0 4.061-1.152 4.061-4.153V20.623h4.244V33.78c0 5.215-3.607 7.73-8.305 7.73-4.76 0-8.368-2.515-8.368-7.73zM190.237 37.175l3.455-2c.91 1.484 2.092 2.576 4.183 2.576 1.759 0 2.881-.88 2.881-2.093 0-1.454-1.152-1.97-3.092-2.818l-1.061-.455c-3.062-1.304-5.093-2.94-5.093-6.397 0-3.182 2.425-5.607 6.214-5.607 2.698 0 4.638.94 6.032 3.395l-3.304 2.121c-.727-1.303-1.515-1.818-2.728-1.818-1.243 0-2.031.788-2.031 1.818 0 1.274.788 1.789 2.607 2.577l1.062.455c3.606 1.547 5.638 3.123 5.638 6.67 0 3.819-3.002 5.91-7.033 5.91-3.941 0-6.487-1.879-7.73-4.334z"/>
						<Path fill="#8596AD" d="M35.272 61.98V41.323H14.615L35.272 61.98z"/>
						<Path fill="#D3D5DE" d="M24.941 30.988L14.615 41.316v.006l.002.002h20.657v-.002L24.941 30.99z"/>
						<Path fill="#8596AD" d="M24.939 30.988l10.327-10.327H14.61h.003L24.94 30.989z"/>
						<Path fill="#FF010B" d="M14.615 20.662v20.652L24.94 30.988 14.615 20.662z"/>
						<Path fill="#D3D5DE" d="M35.268 20.66V0l-20.66 20.66h20.659zM14.607 49.877V20.662L0 35.27l14.607 14.607z"/>
						<Path fill="#8596AD" d="M0 35.269h.001l14.607-14.606v-.003L0 6.052V35.27z"/>
					</Svg>
				</ImgContainer>
				<FormDataContainer>
					<FormDataContainerWrapper>
						<FormDataTitleContainer>
							<FormDataTitle>{GeneralConstants['project_title']}</FormDataTitle>
						</FormDataTitleContainer>
						<FormDataContentContainer>
							<FormDataContent>{activeFormData.title}</FormDataContent>
						</FormDataContentContainer>
					</FormDataContainerWrapper>
					<FormDataContainerWrapper>
						<FormDataTitleContainer>
							<FormDataTitle>{knapphus.order_number.label}</FormDataTitle>
						</FormDataTitleContainer>
						<FormDataContentContainer>
							<FormDataContent>{knapphus.order_number.value}</FormDataContent>
						</FormDataContentContainer>
					</FormDataContainerWrapper>
					<FormDataContainerWrapper>
						<FormDataTitleContainer>
							<FormDataTitle>{knapphus.bathroom_model.label}</FormDataTitle>
						</FormDataTitleContainer>
						<FormDataContentContainer>
							<FormDataContent>{knapphus.bathroom_model.value}</FormDataContent>
						</FormDataContentContainer>
					</FormDataContainerWrapper>
				</FormDataContainer>
				<FormDataContainer>
					<InputHeader>
						<InputHeaderText>{knapphus.lacquer.label}</InputHeaderText>
					</InputHeader>
					<InputWrapper>
						<FormDataContainerWrapper>
							<FormDataTitleContainer>
								<FormDataTitle>{knapphus.lacquer.front.label} (m²)</FormDataTitle>
							</FormDataTitleContainer>
							<FormDataContentContainer>
								<FormDataContent>{knapphus.lacquer.front.value}</FormDataContent>
							</FormDataContentContainer>
						</FormDataContainerWrapper>
						<FormDataContainerWrapper>
							<FormDataTitleContainer>
								<FormDataTitle>{knapphus.lacquer.dekks.label} (m²)</FormDataTitle>
							</FormDataTitleContainer>
							<FormDataContentContainer>
								<FormDataContent>{knapphus.lacquer.dekks.value}</FormDataContent>
							</FormDataContentContainer>
						</FormDataContainerWrapper>
						<FormDataContainerWrapper>
							<FormDataTitleContainer>
								<FormDataTitle>{knapphus.color_code.label}</FormDataTitle>
							</FormDataTitleContainer>
							<FormDataContentContainer>
								<FormDataContent>{knapphus.color_code.value}</FormDataContent>
							</FormDataContentContainer>
						</FormDataContainerWrapper>
						<FormDataContainerWrapper>
							<FormDataTitleContainer>
								<FormDataTitle>{knapphus.lacquer?.moldings_lists?.label}</FormDataTitle>
							</FormDataTitleContainer>
							<FormDataContentContainer>
								<FormDataContent>{knapphus.lacquer?.moldings_lists?.value}</FormDataContent>
							</FormDataContentContainer>
						</FormDataContainerWrapper>
						<FormDataContainerWrapper>
							<FormDataTitleContainer>
								<FormDataTitle>{knapphus.lacquer?.planned_week?.label}</FormDataTitle>
							</FormDataTitleContainer>
							<FormDataContentContainer>
								<FormDataContent>
									{knapphus.lacquer?.planned_week?.value
										? formatDateToDayAndMonthAndYear(knapphus.lacquer?.planned_week?.value)
										: null}
								</FormDataContent>
							</FormDataContentContainer>
						</FormDataContainerWrapper>
					</InputWrapper>
				</FormDataContainer>
			</PageContainer>
		</Document>
	);
};

export default PdfBathroom;
